module.exports = __webpack_public_path__ + "static/media/deposit.b10889a5.png";